const freeLoginStyles = (theme) => ({
    sectionWrapper: {
        marginBottom: '30px',
    },
    centerToRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
        },
    },
    allCenter: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '30px',
    },
    buttonBig: {
        fontSize: '30px !important',
        minWidth: '450px !important',
        padding: '10px !important',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '360px !important',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '18px !important',
            minWidth: '280px !important',
        },
    },
    helperText: {
        maxWidth: '480px',
        [theme.breakpoints.down('md')]: {
            maxWidth: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    flexStart: {
        justifyContent: 'flex-start',
    },
});

export default freeLoginStyles;
